import "./index.css";
import ReactDOM from "react-dom/client";
import BasicAuth from "./components/BasicAuth";
import App from "./main";
import React from "react";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BasicAuth>
      <App />
    </BasicAuth>
  </React.StrictMode>
);
